module.exports = __webpack_public_path__ + "img/ic_benifit_study.5fafac29.png";